import { render, staticRenderFns } from "./IndexHome.vue?vue&type=template&id=036c00c8&scoped=true&"
import script from "./IndexHome.vue?vue&type=script&lang=js&"
export * from "./IndexHome.vue?vue&type=script&lang=js&"
import style0 from "./IndexHome.vue?vue&type=style&index=0&id=036c00c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036c00c8",
  null
  
)

export default component.exports